// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Organization_organizationUrl__yPUNG{
    margin-bottom: 25px;
}
.Organization_dualInputsRow__L47Xh, .Organization_bankInfoRow__D98vJ{
    display: flex;
    margin-bottom: 15px;
}
.Organization_halfLineInput__q4yRU input{
    width: 215px;
}
.Organization_halfLineInput__q4yRU:last-child{
    margin-left: auto;
}
.Organization_halfLineInput__q4yRU select{
    width: 264px;
}
@media(max-width: 930px){
    .Organization_dualInputsRow__L47Xh{
        display: block;
        margin-bottom: 0;
    }
    .Organization_halfLineInput__q4yRU{
        display: block;
        margin-bottom: 15px;
    }
    .Organization_halfLineInput__q4yRU input{
        width: calc(100% - 50px);
    }
    .Organization_halfLineInput__q4yRU{
        width: 100%;
    }
    .Organization_halfLineInput__q4yRU select{
        width: 100%;
    }
}
.Organization_singleLineInput__zsAlS{
    display: block !important;
    margin-bottom: 15px;
}
.Organization_singleLineInput__zsAlS input{
    width: calc(100% - 50px);
}
.Organization_bankInfoRow__D98vJ{
    margin-top: 25px;
    align-items: center;
}
.Organization_bankInfoLabel__f6U8r{
    position: relative;
    top: -2px;
    margin-left: 2px;
    color: #1F363D;
    font-size: 16px;
    font-family: 'Gotham Medium', serif;
}
.Organization_bankIcon__gKHFc{
    position: relative;
    top: 3px;
    height: 20px;
    width: 20px;
    margin-right: 10px;
}
.Organization_exclamation__2zFAT{
    position: relative;
    top: 1px;
    height: 16px;
    width: 18px;
    margin-left: 6px;
}
.Organization_checkmark__TVxyJ{
    position: relative;
    top: 2.5px;
    height: 16px;
    width: 16px;
    margin-left: 7px;
}
.Organization_bankInfoButton__jKZcX{
    height: 38px;
    margin-left: auto;
    padding: 0 30px;
    font-size: 14px;
    border: 1px solid #40798C66;
}
@media(max-width: 400px){
    .Organization_bankIcon__gKHFc{
        margin-right: 5px;
    }
    .Organization_exclamation__2zFAT, .Organization_checkmark__TVxyJ{
        margin-left: 3px;
    }
    .Organization_bankInfoButton__jKZcX{
        padding: 0 15px;
    }
}
.Organization_button__tgSoY{
    width: 261px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    margin-top: 35px;
}`, "",{"version":3,"sources":["webpack://./src/components/profile/Organization.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;IACI;QACI,cAAc;QACd,gBAAgB;IACpB;IACA;QACI,cAAc;QACd,mBAAmB;IACvB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;AACJ;AACA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,mCAAmC;AACvC;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,2BAA2B;AAC/B;AACA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".organizationUrl{\n    margin-bottom: 25px;\n}\n.dualInputsRow, .bankInfoRow{\n    display: flex;\n    margin-bottom: 15px;\n}\n.halfLineInput input{\n    width: 215px;\n}\n.halfLineInput:last-child{\n    margin-left: auto;\n}\n.halfLineInput select{\n    width: 264px;\n}\n@media(max-width: 930px){\n    .dualInputsRow{\n        display: block;\n        margin-bottom: 0;\n    }\n    .halfLineInput{\n        display: block;\n        margin-bottom: 15px;\n    }\n    .halfLineInput input{\n        width: calc(100% - 50px);\n    }\n    .halfLineInput{\n        width: 100%;\n    }\n    .halfLineInput select{\n        width: 100%;\n    }\n}\n.singleLineInput{\n    display: block !important;\n    margin-bottom: 15px;\n}\n.singleLineInput input{\n    width: calc(100% - 50px);\n}\n.bankInfoRow{\n    margin-top: 25px;\n    align-items: center;\n}\n.bankInfoLabel{\n    position: relative;\n    top: -2px;\n    margin-left: 2px;\n    color: #1F363D;\n    font-size: 16px;\n    font-family: 'Gotham Medium', serif;\n}\n.bankIcon{\n    position: relative;\n    top: 3px;\n    height: 20px;\n    width: 20px;\n    margin-right: 10px;\n}\n.exclamation{\n    position: relative;\n    top: 1px;\n    height: 16px;\n    width: 18px;\n    margin-left: 6px;\n}\n.checkmark{\n    position: relative;\n    top: 2.5px;\n    height: 16px;\n    width: 16px;\n    margin-left: 7px;\n}\n.bankInfoButton{\n    height: 38px;\n    margin-left: auto;\n    padding: 0 30px;\n    font-size: 14px;\n    border: 1px solid #40798C66;\n}\n@media(max-width: 400px){\n    .bankIcon{\n        margin-right: 5px;\n    }\n    .exclamation, .checkmark{\n        margin-left: 3px;\n    }\n    .bankInfoButton{\n        padding: 0 15px;\n    }\n}\n.button{\n    width: 261px;\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 35px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"organizationUrl": `Organization_organizationUrl__yPUNG`,
	"dualInputsRow": `Organization_dualInputsRow__L47Xh`,
	"bankInfoRow": `Organization_bankInfoRow__D98vJ`,
	"halfLineInput": `Organization_halfLineInput__q4yRU`,
	"singleLineInput": `Organization_singleLineInput__zsAlS`,
	"bankInfoLabel": `Organization_bankInfoLabel__f6U8r`,
	"bankIcon": `Organization_bankIcon__gKHFc`,
	"exclamation": `Organization_exclamation__2zFAT`,
	"checkmark": `Organization_checkmark__TVxyJ`,
	"bankInfoButton": `Organization_bankInfoButton__jKZcX`,
	"button": `Organization_button__tgSoY`
};
export default ___CSS_LOADER_EXPORT___;
